import PropTypes from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

const Spinner = ({ color, inverse }) => {
  const classes = classnames(
    'spinner',
    { inverse },
    { 'stroke-current': color },
    { 'text-[color:var(--spinner-color)]': color },
  );

  return (
    <svg
      className={classes}
      style={{
        '--spinner-color': color,
      }}
      viewBox="0 0 50 50"
    >
      <circle
        className="path"
        cx="25"
        cy="25"
        fill="none"
        r="20"
        strokeWidth="3"
      />
    </svg>
  );
};

Spinner.propTypes = {
  inverse: PropTypes.bool,
};
export default Spinner;
